import { useEffect, useRef } from 'react';

// One timer per consumer. Hidden tabs do no periodic work; focus catches up.
export default function useVisiblePolling(callback, interval, enabled = true) {
  const latest = useRef(callback);
  latest.current = callback;
  useEffect(() => {
    if (!enabled) return undefined;
    let stopped = false;
    let busy = false;
    let failures = 0;
    let retryAt = 0;
    const tick = async (force = false) => {
      if (stopped || busy || document.hidden || (!force && Date.now() < retryAt)) return;
      busy = true;
      try {
        const result = await latest.current();
        if (result === false) throw new Error('Polling unavailable');
        failures = 0; retryAt = 0;
      } catch {
        failures += 1;
        retryAt = Date.now() + Math.min(interval * (2 ** failures), 300000);
      } finally { busy = false; }
    };
    const foreground = () => tick(true);
    const timer = window.setInterval(tick, interval);
    window.addEventListener('focus', foreground);
    document.addEventListener('visibilitychange', foreground);
    return () => {
      stopped = true;
      window.clearInterval(timer);
      window.removeEventListener('focus', foreground);
      document.removeEventListener('visibilitychange', foreground);
    };
  }, [interval, enabled]);
}
